export default __webpack_public_path__ + "static/finishing_touches-4512c165b6084b9eabdeef134600f33f.png";